import { render, staticRenderFns } from "./SimpleToolbar.vue?vue&type=template&id=0a179f4b&scoped=true"
import script from "./SimpleToolbar.vue?vue&type=script&lang=js"
export * from "./SimpleToolbar.vue?vue&type=script&lang=js"
import style0 from "./SimpleToolbar.vue?vue&type=style&index=0&id=0a179f4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a179f4b",
  null
  
)

export default component.exports